// Terms & Conditions are now stored as Markdown. Older records hold HTML from the previous rich-text editor,
// so they are converted to Markdown on read; text content only, so no markup is ever rendered as HTML.
const HTML_PATTERN = /<\/?[a-z][\s\S]*>/i;

export const isHtml = (text) => HTML_PATTERN.test(text || '');

const SKIPPED_TAGS = new Set(['SCRIPT', 'STYLE']);

const convert = (node, listType) => {
    if (node.nodeType === Node.TEXT_NODE) return node.textContent;
    if (node.nodeType !== Node.ELEMENT_NODE || SKIPPED_TAGS.has(node.tagName)) return '';

    const children = (type = listType) => Array.from(node.childNodes).map((c) => convert(c, type)).join('');

    switch (node.tagName) {
        case 'BR': return '\n';
        case 'P':
        case 'DIV': return `${children()}\n\n`;
        case 'STRONG':
        case 'B': return `**${children()}**`;
        case 'EM':
        case 'I': return `*${children()}*`;
        case 'UL': return `${children('ul')}\n`;
        case 'OL': return `${children('ol')}\n`;
        case 'LI': {
            const marker = listType === 'ol'
                ? `${Array.from(node.parentNode.children).indexOf(node) + 1}.`
                : '-';
            return `${marker} ${children().trim()}\n`;
        }
        default: return children();
    }
};

export const htmlToMarkdown = (html) => {
    const doc = new DOMParser().parseFromString(html || '', 'text/html');
    return convert(doc.body).replace(/\n{3,}/g, '\n\n').trim();
};

export const toMarkdown = (text) => (isHtml(text) ? htmlToMarkdown(text) : (text || ''));
